import { createFileRoute } from '@tanstack/react-router'

import { registerPublicFormsInterceptors } from '@/app/router/public-forms-interceptors'
import { OnboardingPage } from '@/pages/onboarding'

// An organisation's own onboarding link (shared from its organisation settings): the assistant
// starts with that organisation selected instead of asking which one.
export const Route = createFileRoute('/onboarding/$organisationId')({
  beforeLoad: () => registerPublicFormsInterceptors(),
  component: RouteComponent,
})

export const OrganisationOnboardingRoute = Route

function RouteComponent() {
  const { organisationId } = Route.useParams()
  return <OnboardingPage organisationId={organisationId} />
}
